export default "__VITE_ASSET__BOm4L1Ir__"